import { render, staticRenderFns } from "./BvnCard.vue?vue&type=template&id=3846c05f&scoped=true"
import script from "./BvnCard.vue?vue&type=script&lang=js"
export * from "./BvnCard.vue?vue&type=script&lang=js"
import style0 from "./BvnCard.vue?vue&type=style&index=0&id=3846c05f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3846c05f",
  null
  
)

export default component.exports